var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#arrow-left',
                        view: publicPath + 'sprite.svg#view-arrow-left',
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };


//////////////////
// WEBPACK FOOTER
// ./src/svg/arrow-left.svg
// module id = 399
// module chunks = 0